__turbopack_context__.v({
  "ad-info": "general-info-module-scss-module__iR4HlW__ad-info",
  "ad-info-divider": "general-info-module-scss-module__iR4HlW__ad-info-divider",
  "general-info": "general-info-module-scss-module__iR4HlW__general-info",
});
